import { clearManageFlowBooking } from '@/features/manage/manageActions';
import { manageFlowBookingSelector } from '@/features/manage/manageSelectors';
import { useChangeBookingSelection } from '@/hooks/useChangeBookingSelection';
import { useDispatch, useSelector } from '@/store/utils';
import { useEffect, useRef, type FC } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

export const ManageBookingLayout: FC = () => {
  const booking = useSelector(manageFlowBookingSelector);
  const location = useLocation();
  const dispatch = useDispatch();
  const { hasSelection } = useChangeBookingSelection();
  // Tracks the latest hasSelection value so the unmount cleanup can read
  // it lazily — closures capture once, refs are mutable at read time.
  const hasSelectionRef = useRef(hasSelection);
  hasSelectionRef.current = hasSelection;

  useEffect(() => {
    return () => {
      // Preserve manage state when the user is navigating away into the
      // change-booking flow — /purchase needs `manage.booking` and
      // `manage.changeTrips` to drive the exchange search. The state gets
      // overwritten naturally on the next manage-booking entry.
      if (hasSelectionRef.current) return;
      dispatch(clearManageFlowBooking());
    };
  }, [dispatch]);

  const isIndexRoute =
    location.pathname === '/manage-booking' ||
    location.pathname === '/manage-booking/';

  // If on any sub-route but no booking in state, redirect to search
  if (!isIndexRoute && !booking) {
    return <Navigate to="/manage-booking" replace />;
  }

  return <Outlet />;
};
